import styled from 'styled-components';


export const Container = styled.div`
    width: 100%;
    box-sizing: border-box;
    background: #FCFAFA;
    color: #032d34;
`;


/* =========================
   HERO
========================= */

export const Hero = styled.section`
    width: 100%;
    box-sizing: border-box;
    background: #F1E3D4;
    padding: 7em 8vw 6em;

    @media (max-width: 800px) {
        padding: 5em 6vw 4em;
    }

    @media (max-width: 500px) {
        padding: 4em 5vw 3.5em;
    }
`;


export const HeroContent = styled.div`
    width: 100%;
    max-width: 1100px;
    margin: 0 auto;
`;


export const HeroText = styled.div`
    max-width: 850px;

    & > h1 {
        max-width: 850px;
    }

    & > h2 {
        max-width: 750px;
        color: #145f68;
    }

    & > p {
        max-width: 750px;
    }
`;


/* =========================
   GENERIC SECTIONS
========================= */

export const Section = styled.section`
    width: 100%;
    box-sizing: border-box;
    padding: 6em 8vw;

    background: ${({ background }) =>
        background === 'light' ? '#E8F0EF' : '#FCFAFA'
    };

    @media (max-width: 800px) {
        padding: 5em 6vw;
    }

    @media (max-width: 500px) {
        padding: 4em 5vw;
    }
`;


export const SectionInner = styled.div`
    width: 100%;
    max-width: 1050px;
    margin: 0 auto;
`;


export const IntroText = styled.div`
    max-width: 820px;

    & > p:last-child {
        margin-bottom: 0;
    }
`;


/* =========================
   SIX BARRIERS
========================= */

export const BarrierGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1.5em;
    margin-top: 3em;

    @media (max-width: 850px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 550px) {
        grid-template-columns: 1fr;
    }
`;


export const BarrierCard = styled.div`
    position: relative;

    box-sizing: border-box;
    min-height: 220px;

    padding: 2em;

    background: #fff;
    border-radius: 4px;

    box-shadow: 0 4px 20px rgba(3, 45, 52, 0.06);

    display: flex;
    flex-direction: column;
    align-items: flex-start;

    & > p {
        margin-top: 0.75em;
    }
`;


export const BarrierNumber = styled.div`
    color: #145f68;
    font-size: 0.85em;
    font-weight: 700;
    letter-spacing: 0.08em;
    margin-bottom: 0.75em;
`;


export const BarrierTitle = styled.div`
    color: #75391b;
    font-size: 1.15em;
    font-weight: 700;
    letter-spacing: 0.04em;
`;


/* =========================
   IMAGE
========================= */

export const ImageSection = styled.div`
    width: 100%;
    max-width: 1050px;
    margin: 3em auto 0;
`;


export const ImagePlaceholder = styled.div`
    width: 100%;
    min-height: 320px;

    background: #E8F0EF;
    border-radius: 4px;

    display: flex;
    align-items: center;
    justify-content: center;

    color: #145f68;
`;


/* =========================
   FUND
========================= */

export const FundSection = styled.section`
    width: 100%;
    box-sizing: border-box;
    padding: 6em 8vw;

    background: #75391b;
    color: #FCFAFA;

    @media (max-width: 800px) {
        padding: 5em 6vw;
    }

    @media (max-width: 500px) {
        padding: 4em 5vw;
    }
`;


export const Highlight = styled.div`
    max-width: 850px;

    margin-top: 3em;
    padding: 2em 2.25em;

    box-sizing: border-box;

    background: rgba(252, 250, 250, 0.12);
    border-left: 4px solid #FCFAFA;

    & > h3 {
        margin-top: 0;
    }

    & > p:last-child {
        margin-bottom: 0;
    }

    @media (max-width: 500px) {
        padding: 1.5em;
    }
`;


/* =========================
   NOLIA
========================= */

export const NoliaSection = styled.section`
    width: 100%;
    box-sizing: border-box;
    padding: 6em 8vw;

    background: #FCFAFA;

    @media (max-width: 800px) {
        padding: 5em 6vw;
    }

    @media (max-width: 500px) {
        padding: 4em 5vw;
    }
`;


export const NoliaGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5em;

    max-width: 950px;
    margin: 3em 0;

    @media (max-width: 650px) {
        grid-template-columns: 1fr;
    }
`;


export const NoliaCard = styled.div`
    box-sizing: border-box;

    padding: 2em;

    background: #E8F0EF;
    border-radius: 4px;

    & > h3 {
        color: #145f68;
        margin-top: 0;
    }

    & > p:last-child {
        margin-bottom: 0;
    }
`;


/* =========================
   ROUTE
========================= */

export const RouteSection = styled.section`
    width: 100%;
    box-sizing: border-box;
    padding: 6em 8vw;

    background: #F1E3D4;

    @media (max-width: 800px) {
        padding: 5em 6vw;
    }

    @media (max-width: 500px) {
        padding: 4em 5vw;
    }
`;


export const Route = styled.div`
    position: relative;

    max-width: 850px;

    margin-top: 3em;

    display: flex;
    flex-direction: column;
    gap: 0;
`;


export const RouteItem = styled.div`
    position: relative;

    display: flex;
    align-items: flex-start;

    gap: 1.5em;

    padding-bottom: 2.5em;

    &:last-child {
        padding-bottom: 0;
    }

    &:not(:last-child)::after {
        content: '';

        position: absolute;

        left: 1.25em;
        top: 2.5em;
        bottom: 0;

        width: 1px;

        background: rgba(20, 95, 104, 0.25);
    }

    @media (max-width: 500px) {
        gap: 1em;

        &:not(:last-child)::after {
            left: 1em;
        }
    }
`;


export const RouteNumber = styled.div`
    position: relative;
    z-index: 2;

    flex: 0 0 2.5em;

    width: 2.5em;
    height: 2.5em;

    box-sizing: border-box;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 50%;

    background: #145f68;
    color: #fff;

    font-weight: 700;
`;


export const RouteContent = styled.div`
    flex: 1;

    & > h3 {
        margin-top: 0;
        color: #145f68;
    }

    & > p:last-child {
        margin-bottom: 0;
    }
`;


/* =========================
   COLLABORATION
========================= */

export const CollaborationSection = styled.section`
    width: 100%;
    box-sizing: border-box;
    padding: 6em 8vw;

    background: #FCFAFA;

    @media (max-width: 800px) {
        padding: 5em 6vw;
    }

    @media (max-width: 500px) {
        padding: 4em 5vw;
    }
`;


export const CollaborationGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);

    gap: 1.5em;

    margin-top: 3em;

    @media (max-width: 700px) {
        grid-template-columns: 1fr;
    }
`;


export const CollaborationCard = styled.div`
    box-sizing: border-box;

    padding: 2em;

    border: 1px solid rgba(20, 95, 104, 0.15);
    border-radius: 4px;

    background: #fff;

    & > h3 {
        margin-top: 0;
        color: #145f68;
    }

    & > p:last-child {
        margin-bottom: 0;
    }
`;


/* =========================
   LEARNING
========================= */

export const LearningSection = styled.div`
    max-width: 850px;

    margin-top: 2.5em;
    padding: 2em 2.25em;

    box-sizing: border-box;

    background: #E8F0EF;
    border-radius: 4px;

    & > h3 {
        margin-top: 0;
        color: #145f68;
    }

    @media (max-width: 500px) {
        padding: 1.5em;
    }
`;


export const LearningList = styled.ul`
    max-width: 850px;

    margin-top: 1.5em;
    padding-left: 1.4em;

    & li {
        margin-bottom: 0.75em;
        padding-left: 0.25em;
    }

    & li:last-child {
        margin-bottom: 0;
    }
`;


/* =========================
   STARTEN / LEREN / VERBETEREN
========================= */

export const StartSection = styled.section`
    width: 100%;
    box-sizing: border-box;
    padding: 6em 8vw;

    background: #E8F0EF;

    @media (max-width: 800px) {
        padding: 5em 6vw;
    }

    @media (max-width: 500px) {
        padding: 4em 5vw;
    }
`;


export const StartFlow = styled.div`
    max-width: 1000px;

    margin: 3em 0;

    display: grid;
    grid-template-columns: repeat(4, 1fr);

    align-items: stretch;

    @media (max-width: 750px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 450px) {
        grid-template-columns: 1fr;
    }
`;


export const StartItem = styled.div`
    min-height: 100px;

    padding: 1.5em;

    box-sizing: border-box;

    display: flex;
    align-items: center;
    justify-content: center;

    background: #FCFAFA;

    text-align: center;

    border-right: 1px solid rgba(20, 95, 104, 0.15);

    &:last-child {
        border-right: none;
    }

    & strong {
        color: #145f68;
    }

    @media (max-width: 750px) {
        border-right: none;
        border-bottom: 1px solid rgba(20, 95, 104, 0.15);

        &:nth-child(odd) {
            border-right: 1px solid rgba(20, 95, 104, 0.15);
        }

        &:last-child {
            border-bottom: none;
        }
    }

    @media (max-width: 450px) {
        border-right: none !important;
    }
`;


/* =========================
   CTA GROUP
========================= */

export const CTAGroup = styled.section`
    width: 100%;
    box-sizing: border-box;

    padding: 5em 8vw;

    background: #145f68;
    color: #FCFAFA;

    text-align: center;

    display: flex;
    flex-direction: column;
    align-items: center;

    & > h2 {
        max-width: 850px;
    }

    & > p {
        max-width: 700px;
    }

    @media (max-width: 800px) {
        padding: 4em 6vw;
    }

    @media (max-width: 500px) {
        padding: 3.5em 5vw;
    }
`;


/* =========================
   PROFESSIONALS / PARENTS
========================= */

export const ParentSection = styled.section`
    width: 100%;
    box-sizing: border-box;

    padding: 6em 8vw;

    background: #F1E3D4;

    @media (max-width: 800px) {
        padding: 5em 6vw;
    }

    @media (max-width: 500px) {
        padding: 4em 5vw;
    }
`;


/* =========================
   FAQ
========================= */

export const FAQSection = styled.section`
    width: 100%;
    box-sizing: border-box;

    padding: 6em 8vw;

    background: #FCFAFA;

    @media (max-width: 800px) {
        padding: 5em 6vw;
    }

    @media (max-width: 500px) {
        padding: 4em 5vw;
    }
`;


export const FAQItem = styled.div`
    max-width: 900px;

    padding: 2em 0;

    border-bottom: 1px solid rgba(20, 95, 104, 0.15);

    &:first-of-type {
        margin-top: 1em;
    }

    & > h3 {
        color: #145f68;
        margin-top: 0;
        margin-bottom: 0.6em;
    }

    & > p:last-child {
        margin-bottom: 0;
    }
`;


/* =========================
   CLOSING
========================= */

export const ClosingSection = styled.section`
    width: 100%;
    box-sizing: border-box;

    padding: 7em 8vw;

    background: #75391b;
    color: #FCFAFA;

    @media (max-width: 800px) {
        padding: 5em 6vw;
    }

    @media (max-width: 500px) {
        padding: 4em 5vw;
    }
`;


export const ClosingContent = styled.div`
    max-width: 850px;
    margin: 0 auto;

    text-align: center;

    display: flex;
    flex-direction: column;
    align-items: center;

    & > h2 {
        max-width: 850px;
    }

    & > h3 {
        max-width: 800px;
        margin-top: 2em;
    }

    & > p {
        max-width: 750px;
    }
`;